import { Route } from "react-router-dom";
import { PreserveState } from "src/components/Navigation/PreserveState";
import { RequireUserPermissions } from "src/components/Permissions/RequireUserPermissions";
import { New as NewFormTemplate } from "src/scenes/orgAdmin/formTemplates/New";
import * as Url from "src/services/url";
import { FormTemplates } from "src/services/url/OrgAdmin";
import { Enrollments } from ".";
import { FormTemplateRoutes } from "../formTemplates/routes";
import { EditEnrollmentPeriod } from "./Edit";
import { NewEnrollmentPeriod } from "./New";

export const EnrollmentPeriodRoutes = (
  <Route
    path={Url.OrgAdmin.Enrollments.indexPath}
    element={
      <PreserveState>
        <RequireUserPermissions permission="navigation.admin.enrollment_periods">
          <Enrollments />
        </RequireUserPermissions>
      </PreserveState>
    }
  >
    <Route
      path={Url.OrgAdmin.Enrollments.newPath}
      element={
        <RequireUserPermissions permission="enrollment_period:create">
          <NewEnrollmentPeriod />
        </RequireUserPermissions>
      }
    />
    <Route
      path={Url.OrgAdmin.Enrollments.editPath}
      element={
        <RequireUserPermissions permission="enrollment_period:update">
          <EditEnrollmentPeriod />
        </RequireUserPermissions>
      }
    />
    <Route
      path={FormTemplates.newPath}
      element={
        <RequireUserPermissions permission="form_template:create">
          <NewFormTemplate />
        </RequireUserPermissions>
      }
    />
    {FormTemplateRoutes}
  </Route>
);
